import {Suspense} from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'
import {AppWrapper} from './AppWrapper'
import {PageLoadingSpinner} from './components/common/PageLoadingSpinner'
import {init as initLocalization} from './localization'
import {GlobalProviders} from './providers/GlobalProviders'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore hack to disable react overlay for Cypress
if (typeof window.Cypress !== 'undefined') {
  require('./disableErrorOverlay.css')
  console.info('Cypress detected, disabling React Error Overlay')
}
void initLocalization()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Suspense fallback={<PageLoadingSpinner />}>
    <GlobalProviders>
      <AppWrapper />
    </GlobalProviders>
  </Suspense>
)
